import React, { useState } from 'react';
import Svg from '@justgiving/svg';
import linkIcon from '@justgiving/icons/lib/link.svg';
import classNames from 'classnames';

import styles from '../SocialButtons/SocialButtonsList.scss';
import IconButton from '../IconButton/IconButton';
import { usePageMeta } from '../../hooks/usePageMeta';

export interface CopyLinkProps {
  onClick?: () => void;
}

export const CopyLinkShareButton: React.FunctionComponent<CopyLinkProps> = ({
  onClick = () => {},
}) => {
  const { currentUrl } = usePageMeta();
  const [buttonText, setButtonText] = useState('Copy link');

  async function onCopy() {
    onClick();
    try {
      await navigator.clipboard.writeText(currentUrl);
      setButtonText('Copied');
    } catch (e) {
      setButtonText('Copy failed');
    }

    setTimeout(() => {
      setButtonText('Copy link');
    }, 3000);
  }

  return (
    <IconButton className={styles.copy} onClick={() => onCopy()}>
      <div>
        <Svg className={classNames(styles.icon)} markup={linkIcon} />
      </div>
      <div className={styles.url}>{currentUrl}</div>
      <span className={styles.copyButtonText}>{buttonText}</span>
    </IconButton>
  );
};
